import React from 'react'
import { createRoot } from 'react-dom/client';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import { thunk as thunkMiddleware } from 'redux-thunk'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './Containers/App'

import commonActions from './Actions/commonActions'
import SearchReducer from './Reducers/SearchReducer'
import CustomerReducer from './Reducers/CustomerReducer'
import CommonReducer from './Reducers/CommonReducer'
import OrderReducer from './Reducers/OrderReducer'
import AppointmentReducer from './Reducers/AppointmentReducer'
import MyDashboardReducer from './Reducers/MyDashboardReducer'
import ActionLogReducer from './Reducers/ActionLogReducer'
import SettingsReducer from './Reducers/SettingsReducer'
import FileBoxReducer from './Reducers/FileBoxReducer';
import DiscountReducer from './Reducers/DiscountReducer';
import LeadsReducer from './Reducers/LeadsReducer'
import QuotationReducer from './Reducers/QuotationReducer'
import GraphReducer from './Reducers/GraphReducer';
import InternalCustomerAdminReducer from './Reducers/InternalCustomerAdmin/InternalCustomerAdminReducer';
import TargetGroupsReducer from "./Reducers/Voss/TargetGroupsReducer";
import PackageReducer from './Reducers/Voss/PackageReducer';
import ProductOverviewReducer from './Reducers/ProductOverviewReducer';
import BokaMeraReducer from "./Reducers/BokaMeraReducer";
import DiscountAgreementsReducer from './Reducers/Voss/DiscountAgreementsReducer';
import SubscriptionReducer from './Reducers/Voss/SubscriptionReducer';
import FormReducer from "./Reducers/FormReducer";
import BankruptcyTerminationReducer from './Reducers/BankruptcyTerminationReducer';
import PriceSimulationReducer from "./Reducers/PriceSimulationReducer";
import {I18nextProvider} from "react-i18next";
import i18n from "./i18n";

const reducers = combineReducers({
    SearchReducer,
    CustomerReducer,
    CommonReducer,
    OrderReducer,
    AppointmentReducer,
    MyDashboardReducer,
    ActionLogReducer,
    SettingsReducer,
    LeadsReducer,
    QuotationReducer,
    GraphReducer,
    ProductOverviewReducer,
    FileBoxReducer,
    BokaMeraReducer,
    DiscountReducer,
    InternalCustomerAdminReducer,
    TargetGroupsReducer,
    PackageReducer,
    DiscountAgreementsReducer,
    SubscriptionReducer,
    FormReducer,
    BankruptcyTerminationReducer,
    PriceSimulationReducer
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunkMiddleware)))
const dispatch = store.dispatch
const container = document.getElementById('root');
const root = createRoot(container);
const urlParams = new URLSearchParams(window.location.search);
const openModalParam = urlParams.get('openModal');

//if(window.location.hostname === "localhost") {
    // Uncomment for testing
    //var url = "https://skynet.stage.vismaspcs.se" + location.pathname + location.search;
    //window.location.href = url;
//}

root.render(
  <Provider store={store}>
    <Router>
        <I18nextProvider i18n={i18n}>
            <App />
        </I18nextProvider>
    </Router>
  </Provider>
);

dispatch(commonActions.getStartupParameters())
dispatch(commonActions.getUserInfo())
dispatch(commonActions.getExternalUrls())
dispatch(commonActions.getFrontendSettings())

if(openModalParam){
    dispatch(commonActions.activateModal(openModalParam));
}

const darkMode = localStorage.getItem("dark-mode");
if (!!darkMode && darkMode !== 'light-theme') {
  document.querySelector("html").classList.add("dark-theme");
} else {
  document.querySelector("html").classList.add("light-theme");
}